let React     = require('react');
let ReactDom  = require('react-dom');

import Utils from 'utils';
// -------------------------------------------------------

/*
 * ユーザーオプション モーダルウィンドウ
 */
class DropDown extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    // DropDownメニューのキー
    let key = this.props.data.key;
    this.base_class = 'dropdown_'+ key;
    this.sub_class  = 'modalmenu_'+ key;
    
    document.getElementById('contents').addEventListener('click', function(e){
      if( this.state.view == false ) return false;
      
      if( Utils.getParentClass(e.target, this.sub_class) == null && Utils.getParentClass(e.target, this.base_class) == null ){
        this.close.bind(this)();
      }
    }.bind(this));
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      view: false,
    };
  }
  // -------------------------------------------------------
  
  componentDidUpdate(nextProps){
    if( nextProps.hide == true ) this.setState({ view: false });
  }
  // -------------------------------------------------------
  
  /*
   * プルダウンの表示
   */
  open(e){
    e.stopPropagation();
    e.preventDefault();
    
    let flg = (this.state.view) ? false : true;
    this.setState({ view: flg });
  }
  // -------------------------------------------------------
  
  /*
   * プルダウンの表示
   */
  close(){
    this.setState({ view: false });
  }
  // -------------------------------------------------------
  
  /*
   * クリック処理
   */
  clickEvent(){
    if( this.props.data.hide != true ) return;
    this.setState({ view: false });
  }
  // -------------------------------------------------------
  
  /*
   * 出力処理
   */
  render() {
    let classname = this.props.data.classname;
    if( classname == undefined ) classname = '';
    
    let active = (this.props.data.menu.length > 0) ? 'true' : 'false';
    
    return (
      <div className={'dropdown '+ classname +' '+ this.base_class +' '+ this.props.style}>
        { (this.state.view)
          ? <div className={'dropdown-btn '+ active} style={{pointerEvents: 'none'}}>
              { this.props.data.btn }
            </div>
          : <div className={'dropdown-btn '+ active} onClick={this.open.bind(this)}>
              { this.props.data.btn }
            </div>
        }
        
        { this.state.view == true ?
          <ul className={'modal-menu '+ this.sub_class} onClick={this.clickEvent.bind(this)}>
            { this.props.data.menu.map((item) => {
              return item;
            })}
          </ul>
        : null }
      </div>
    );
  }
}

// レンダリング処理
export default DropDown;